/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Continue1Inputs */

const en_newpatient_continue1 = /** @type {(inputs: Newpatient_Continue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const fr_newpatient_continue1 = /** @type {(inputs: Newpatient_Continue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Newpatient_Continue1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_continue1 = /** @type {((inputs?: Newpatient_Continue1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Continue1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_continue1(inputs)
	return fr_newpatient_continue1(inputs)
});
export { newpatient_continue1 as "newPatient_continue" }